export enum FilterValueType {
  Type = 'Type',
  OrganisationUnit = 'OrganisationUnit',
  Status = 'Status',
  Reason = 'Reason',
}
